<div class="asset-tile" data-placement="top">
  <div class="asset-tile-container" [tabindex]="0">
    <div class="asset-tile-top">
      <img
        class="asset-tile-top-asset-group-logo"
        [src]="asset.logo"
        (error)="img.src = '/assets/images/default-asset.svg'"
        alt="{{ asset.name + '_alt_text' | translate }}"
        #img />
      <span [title]="asset.name | translate" class="asset-tile-top-name">
        {{ asset.name | translate }}
      </span>
    </div>
    <div class="asset-tile-amount" hidePortfolioValue [isHideActive]="isHidePortfolioActive">
      <div class="asset-tile-amount-crypto">
        <strong>
          {{
          asset.assetBalance
          | fiat_precision_symbol
          : {
          id: asset.id,
          symbol: true
        }
        }}
      </strong>
    </div>
    <div class="asset-tile-amount-fiat">
      @if (asset.showFiatConversion) {
        <span>
          {{
          asset.fiatBalance
          | fiat_precision_symbol
          : {
          id: defaultFiat?.getId(),
          symbol: true,
          currencies: [defaultFiat]
        }
        }}
      </span>
    }
  </div>
</div>
</div>

@if (isCashPlusOptIn && isCashPlusEligible) {
  <div class="cash-plus">
    <div class="wallet-balance">
      <div class="wallet-balance-title">{{ "wallet_balance" | translate }}</div>
      <div class="wallet-balance-amount" hidePortfolioValue [isHideActive]="isHidePortfolioActive">{{
        asset.availableAssetBalance
        | fiat_precision_symbol
        : {
        id: asset.id,
        symbol: false,
        currencies: [defaultFiat]
      }
    }}</div>
  </div>
  <div class="cash-plus-balance">
    <div class="cash-plus-balance-title">{{ "portfolio_cash_plus_balance" | translate }}</div>
    <div class="cash-plus-balance-amount" hidePortfolioValue [isHideActive]="isHidePortfolioActive">{{
      asset.parkedAssetBalance
      | fiat_precision_symbol
      : {
      id: asset.id,
      symbol: false,
      currencies: [defaultFiat]
    }
  }}</div>
</div>
</div>
}
</div>
